import React, { useEffect, useState, useRef } from 'react';
import styled from 'styled-components/native';
import { AudioLibrary } from '../hooks/AudioLibrary';
import { Audio } from 'expo-av';
import AsyncStorage from '@react-native-async-storage/async-storage';

let globalSound = null;

function AudioPlayer({lastPlayedSong, callbackFunction, callbackFunctionCloseMenu}) {

  const [currentSong, setCurrentSong] = useState(AudioLibrary[lastPlayedSong]);
  const [isAudioPlaying, setIsAudioPlaying] = useState(false);
  const soundRef = useRef(null);

  async function playAudio() {
    //console.log('playAudio: Loading sound for', currentSong.name);
    try {
      // Check if a global sound instance already exists
      if (globalSound) {
        //console.log('playAudio: Unloading previous sound');
        await globalSound.unloadAsync();
      } else {
        // If not, create a new instance
        globalSound = new Audio.Sound();
      }

      await globalSound.loadAsync(currentSong.path);
      //console.log('playAudio: Sound loaded', currentSong.name);

      soundRef.current = globalSound;
      setIsAudioPlaying(true);
      //console.log('playAudio: Playing sound', currentSong.name);
      await globalSound.playAsync();
    } catch (error) {
      console.error('playAudio: Error loading sound', error);
    }
  }


  async function handlePlayPause() {
    if (!soundRef.current) {
      //console.log('handlePlayPause: No sound reference');
      return;
    }

    if (isAudioPlaying) {
      //console.log('handlePlayPause: Pausing sound');
      await soundRef.current.pauseAsync();
    } else {
      //console.log('handlePlayPause: Playing sound');
      await soundRef.current.playAsync();
    }

    setIsAudioPlaying(!isAudioPlaying);
  }

  async function updateCurrentSong(song) {
    console.log('updateCurrentSong: Updating song to', song.name);
    await AsyncStorage.setItem('lastPlayedSong', song.name);
    setCurrentSong(song); // Directly set the new song
  }

  useEffect(() => {
    if (currentSong) {
      //console.log('useEffect: Current song changed to', currentSong.name);
      playAudio(); // Call playAudio directly when currentSong changes
    }
  }, [currentSong]);

  useEffect(() => {
    //console.log('useEffect: Initial playAudio call');
    playAudio();
    return () => {
      if (soundRef.current) {
        //console.log('useEffect: Unloading sound on cleanup');
        soundRef.current.unloadAsync();
      }
    };
  }, []);

  useEffect(() => {
    if (soundRef.current && currentSong) {
      //console.log('useEffect: Current song changed to', currentSong.name);
      soundRef.current.unloadAsync().then(() => {
        playAudio();
      });
    }
  }, [currentSong]);

  function songListCallback(newSong) {
    //console.log('songListCallback: New song selected', newSong.name);
    if (newSong) {
      console.log('new song' , newSong);
      updateCurrentSong(newSong);
    }

    callbackFunctionCloseMenu();
  }

  return (
      <AudioPlayerParent>

        {/* {isDropMenuOpen == true && (
            <SongList callbackFunction={songListCallback}/>
        )} */}

        <AudioPlayerCurrentSong>
          {isAudioPlaying == false && (
              <Waveform
                  style={{
                    width:50,
                    height:50,
                    marginRight:15
                  }}
                  source={{
                    uri: `https://cerebrocoreusa.com/wp-content/plugins/advanced-healthcare-solutions/media/fb_static.png`,
                  }}
                  resizeMode='contain'
              />
          )}
          {isAudioPlaying == true && (
              <Waveform
                  style={{
                    width:50,
                    height:75,
                    marginRight:15
                  }}
                  source={{
                    uri: `https://cerebrocoreusa.com/wp-content/plugins/advanced-healthcare-solutions/media/fb_anim.gif`,
                  }}
              />
          )}
          <Song>{currentSong.name}</Song>
        </AudioPlayerCurrentSong>

        <SongListButton
            onPress={() => { callbackFunction(songListCallback, currentSong.name) }}
        >
          <SongListButtonText>
            Change Audio
          </SongListButtonText>
        </SongListButton>
      </AudioPlayerParent>
  );
}

export const AudioPlayerParent = styled.View`
    position:absolute;
    bottom:15px;
    left:0;
    right:0;
    width:100%;
    height:auto;
    display:flex;
    justify-content:center;
    align-items:center;
`

export const AudioPlayerCurrentSong = styled.View`
    width:100%;
    max-width:250px;
    height:auto;
    display:flex;
    justify-content:center;
    align-items:center;
    flex-direction:row;
    margin-bottom:5px;
`

export const Waveform = styled.Image`

`

export const Song = styled.Text`
    font-family:'Montserrat-RG';
    color:#3366cc;
    font-size:18px;
    flex:1;
    flex-wrap:wrap;
`

export const SongListButton = styled.TouchableOpacity`
    width:100%;
    max-width:300px;
    height:40px;
    display:flex;
    justify-content:center;
    align-items:center;
    background:#eff2f6;
    border-radius:50px;
`

export const SongListButtonText = styled.Text`
    font-family:'Montserrat-RG';
    color:#a6bcd3;
    font-size:16px;
`

export default AudioPlayer;
